import Vue from 'vue';

import Component from '@/components/index';
Vue.use(Component);

async function init(app) {
  $$.vue = new Vue({
    render: (h) =>
      h({
        name: 'App',
        render() {
          return <page-view />;
        }
      })
  }).$mount(app);
}

export default { init };
